import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { DraftPlaylist, PlaylistStatus } from "../../../type";
import { PlaylistAction } from "../playlistReducer";
import { LegacyLoader } from "../../../../../../components/Loader/Loader";
import { TITLE_MAX_LEN, DESCRIPTION_MAX_LEN } from "../../const";

import "./TeacherPlaylistDescribe.scss";
interface TeacherPlaylistDescribeProps {
    playlist: DraftPlaylist;
    dispatch: React.Dispatch<PlaylistAction>;
}

const TeacherPlaylistDescribe = ({
    playlist,
    dispatch,
}: TeacherPlaylistDescribeProps) => {
    const intl = useIntl();

    if (typeof playlist.name === "undefined") return <LegacyLoader />;

    return (
        <div className="teacher-playlist-describe" key="describe">
            <form>
                <label htmlFor="playlist-input-title">
                    {intl.formatMessage(messages.playlistTitle)}
                </label>
                <input
                    maxLength={TITLE_MAX_LEN}
                    className="playlist-form-input"
                    type="text"
                    id="playlist-input-title"
                    value={playlist.name}
                    onChange={(e) =>
                        dispatch({
                            type: "update_name",
                            name: e.target.value,
                        })
                    }
                    disabled={playlist.status.status !== PlaylistStatus.DRAFT}
                />

                <label htmlFor="playlist-input-description">
                    {intl.formatMessage(messages.playlistDescription)}
                </label>
                <p>{intl.formatMessage(messages.playlistDescriptionDetail)}</p>
                <div className="playlist-form-input playlist-form-input__description">
                    <textarea
                        className="playlist-form-description__textarea"
                        maxLength={DESCRIPTION_MAX_LEN}
                        id="playlist-input-description"
                        onChange={(e) =>
                            dispatch({
                                type: "update_description",
                                description: e.target.value,
                            })
                        }
                        value={playlist?.description}
                        disabled={
                            playlist.status.status !== PlaylistStatus.DRAFT
                        }
                    />
                    {playlist.status.status === PlaylistStatus.DRAFT && (
                        <div className="playlist-form-description_count">
                            {`${
                                playlist.description?.length ?? 0
                            } / ${DESCRIPTION_MAX_LEN} ${intl.formatMessage(
                                messages.countedChars
                            )}`}
                        </div>
                    )}
                </div>
            </form>
        </div>
    );
};

export default TeacherPlaylistDescribe;

const messages = defineMessages({
    playlistTitle: {
        id: "playlist-title",
        defaultMessage: "Title",
    },
    playlistDescription: {
        id: "playlist-description",
        defaultMessage: "Description",
    },
    playlistDescriptionDetail: {
        id: "playlist-description-detail",
        defaultMessage:
            "This description will be visible to you and all students who receive this playlist, now or later.",
    },
    countedChars: {
        id: "counted-chars",
        defaultMessage: "characters",
    },
});
